import {put, takeLatest, select} from 'redux-saga/effects';
import axios from "axios";
import {FIND_GAME_SESSION, FIND_GAMESESSION_ID} from '../../api/index'

function* findGameSession(){
  try{
    const gamesession =  yield axios.post(FIND_GAME_SESSION)
      .then(res => res.data);
    if(gamesession.status !== 200){
      yield timeout(5000);
      yield put ({"type": "FIND_GAME_SESSION"});
    } else {
      yield put ({"type": "GAME_FOUND", payload: gamesession.gs});
    }
  }catch(err){
    yield timeout(5000);
    yield put ({"type": "FIND_GAME_SESSION"});
  }
};

function* fetchGsIncrementals(){
  try{
    const state = yield select();
    const gsID = state.gameSession.activeSession.sessionID;
    const gamesession =  yield axios.post(FIND_GAMESESSION_ID, {"gsID": gsID})
      .then(res => res.data);
    if(gamesession.status !== 200){
      yield timeout(6000);
      yield put ({"type": "FETCH_GS_INCREMENTALS"});
    } else {
      yield put ({"type": "GAME_FOUND", payload: gamesession.gs});
      // yield timeout(6000);
      // yield put ({"type": "FETCH_GS_INCREMENTALS"});
    }
  }catch(err){
    // yield timeout(6000);
    // yield put ({"type": "FETCH_GS_INCREMENTALS"});
  }
}

export function* findGameSessionWatcher(){
  yield takeLatest("FIND_GAME_SESSION", findGameSession);
};

export function* fetchGsIncrementalsWatcher(){
  yield takeLatest("FETCH_GS_INCREMENTALS", fetchGsIncrementals);
}

export default [findGameSessionWatcher(),fetchGsIncrementalsWatcher()];

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
};